import React from "react";
import { Form } from "react-bootstrap";
import axios from 'axios';
import { Card, CardBody, CardHeader } from "../../../_metronic/_partials/controls/Card";
import Loader from "react-loader-spinner";
import { Button, Modal, Dropdown, DropdownButton } from "react-bootstrap";
import PopupModal from '../modal/popupmodal';
import CheckPermission from "../../General/CheckPermission";
import RBAC, { ModulesName, UserActions } from "../../General/roleModuleActions";
import { Animated } from "react-animated-css";


const validateEmail = (email) => {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email?.trim() || '');
};

const validateName = (name) => {
    if (!name || name.trim().length <= 2) {
        return false;
    }
    // Check if name contains any numbers
    const hasNumbers = /\d/.test(name.trim());
    return !hasNumbers;
};

const getRoleNameFromRBAC = (roleID) => {
    // Map roleID to RBAC role names

    if (roleID === 9) {
        return "Nurse 1";
    } else if (roleID === 10) {
        return "Nurse 2";
    } 

    const roleMapping = {
        1: RBAC.Role_Gentell_Administrator,
        2: RBAC.Role_Gentell_RegionalManager,
        3: RBAC.Role_Gentell_WoundCareSpecialist,
        4: RBAC.Role_Gentell_SeniorBiller,
        5: RBAC.Role_Gentell_IntakeProcessor,
        6: RBAC.Role_Gentell_QualityTeam,
        7: RBAC.Role_Facility_CorporateClinician,
        8: RBAC.Role_Facility_RegionalClinician,
        9: RBAC.Role_Facility_Level1,
        10: RBAC.Role_Facility_Level2,
        11: RBAC.Role_Facility_MDSCoordinator,
        12: RBAC.Role_Facility_Surveyor,
        13: RBAC.Role_Facility_Physician,
        14: RBAC.Role_Facility_ReadOnly,
        15: RBAC.Role_Gentell_Trainer,
        16: RBAC.Role_Gentell_WarehouseManager,
        17: RBAC.Role_Gentell_OutsSpecialist,
        18: RBAC.Role_Gentell_EnteralSpecialist,
        19: RBAC.Role_Gentell_OutsSpecialist,
        20: RBAC.Role_Gentell_EnteralSpecialist
    };
    
    return roleMapping[roleID] || `Role ${roleID}`;
};

const validateForm = (user, touched = {}) => {
    const errors = {};
    const isValid = {};
    
    // Validate firstName - only show error if field has been touched and is invalid
    if (!validateName(user.firstName)) {
        isValid.firstName = false;
        if (touched.firstName) {
            if (!user.firstName || user.firstName.trim().length <= 2) {
                errors.firstName = "Enter proper first name (minimum 3 characters)";
            } else if (/\d/.test(user.firstName.trim())) {
                errors.firstName = "First name cannot contain numbers";
            } else {
                errors.firstName = "Enter proper first name";
            }
        }
    } else {
        isValid.firstName = true;
    }
    
    // Validate lastName - only show error if field has been touched and is invalid
    if (!validateName(user.lastName)) {
        isValid.lastName = false;
        if (touched.lastName) {
            if (!user.lastName || user.lastName.trim().length <= 2) {
                errors.lastName = "Enter proper last name (minimum 3 characters)";
            } else if (/\d/.test(user.lastName.trim())) {
                errors.lastName = "Last name cannot contain numbers";
            } else {
                errors.lastName = "Enter proper last name";
            }
        }
    } else {
        isValid.lastName = true;
    }
    
    // Validate email - only show error if field has been touched and is invalid
    if (!validateEmail(user.email)) {
        isValid.email = false;
        if (touched.email) {
            errors.email = "Enter proper email";
        }
    } else {
        isValid.email = true;
    }
    
    const isFormValid = isValid.firstName && isValid.lastName && isValid.email;
    
    return { errors, isValid, isFormValid };
};

export default class UserRoleForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            IsLoading: false,
            User: this.props.user || {},
            facilityName: this.props.facilityName,
            userList: this.props.userList,
            firstNameDisabled: false,
            lastNameDisabled: false,
            // emailDisabled: this.props.isEditMode || false,
            roleID: this.props.roleID,
            errors: {},
            isValid: {},
            isFormValid: false,
            touched: {}, 
            // UserID:"",
            // RoleID:"",
            // CreatedBy:1,
            // CreatedDate:"",
            facilityUser:
            {
                fkOperatorsPurchasingGroupId: props.operatorsPurchasingGroupID != '' ? props.operatorsPurchasingGroupID : null,
                fkOwnershipHeadquartersId: props.ownershipHeadquartersID != '' ? props.ownershipHeadquartersID : null,
                fkFacilityId: props.facilityID != '' ? props.facilityID : null,
                facilityUserList: []
            }
        };
    }

    componentDidMount(){
        this.setState({ 
            IsLoading: true 
        });
        // Initialize validation on mount
        this.validateForm();
    }

    // Method to notify parent component about validation status
    notifyValidationStatus = (isValid) => {
        if (this.props.onValidationChange) {
            this.props.onValidationChange(isValid);
        }
    };

    validateForm = () => {
        const { User, touched } = this.state;
        const validation = validateForm(User, touched);
        
        this.setState({
            errors: validation.errors,
            isValid: validation.isValid,
            isFormValid: validation.isFormValid
        }, () => {
            this.notifyValidationStatus(validation.isFormValid);
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState(prevState => ({
            User: {
                ...prevState.User, 
                [name]: value      
            },
            touched: {
                ...prevState.touched,
                [name]: true 
            }
        }), () => {
            this.validateForm();
        });
    }

    handleSubmit= (e) =>{
        const {User} = this.state
        const formData = {
            ...User,
            roleID: this.props.isEditMode ? User.roleID : 10  // 10 = Nurse 2 role ID
        };
        this.props.onSave(formData);
    }

    render() {
        return (
           <>
           {(this.state.IsLoading == true) ?
                <div>
                    <Form onSubmit={this.handleSubmit} >

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label htmlFor="firstName" className="form-label">First Name</label>
                                <input 
                                    type="text" 
                                    id="firstName" 
                                    name="firstName"
                                    className={`form-control ${this.state.errors.firstName ? 'is-invalid' : ''}`}
                                    placeholder="First Name" 
                                    value={this.state.User.firstName || ""}
                                    onChange={this.handleChange}
                                    required
                                />
                                {this.state.errors.firstName && (
                                    <div className="invalid-feedback">
                                        {this.state.errors.firstName}
                                    </div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="lastName" className="form-label">Last Name</label>
                                <input 
                                    type="text" 
                                    id="lastName" 
                                    name="lastName"
                                    className={`form-control ${this.state.errors.lastName ? 'is-invalid' : ''}`}
                                    placeholder="Last Name" 
                                    value={this.state.User.lastName || ""}
                                    onChange={this.handleChange}
                                    required
                                />
                                {this.state.errors.lastName && (
                                    <div className="invalid-feedback">
                                        {this.state.errors.lastName}
                                    </div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input 
                                    type="email" 
                                    id="email" 
                                    name="email"
                                    className={`form-control ${this.state.errors.email ? 'is-invalid' : ''}`}
                                    placeholder="Email" 
                                    value={this.state.User.email || ""}
                                    onChange={this.handleChange}
                                    disabled = {this.props.isEditMode && this.props.roleID !== RBAC.Role_Gentell_Administrator}
                                    required
                                />
                                {this.state.errors.email && (
                                    <div className="invalid-feedback">
                                        {this.state.errors.email}
                                    </div>
                                )}
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="assignedFacility" className="form-label">Assigned Facility</label>
                                <input 
                                    type="text" 
                                    id="assignedFacility" 
                                    name="assignedFacility"
                                    className="form-control"
                                    value={this.state.facilityName}
                                    disabled 
                                    required
                                />
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="userRole" className="form-label">User Role</label>
                                <input 
                                    type="text" 
                                    id="userRole" 
                                    name="userRole"
                                    className="form-control" 
                                    // value="Nurse 2"
                                    // value={getRoleNameFromRBAC(this.state.User.roleID)}
                                    value={this.props.isEditMode ? getRoleNameFromRBAC(this.state.User.roleID): "Nurse 2"}
                                    disabled 
                                    required
                                />
                            </div>
                        </div>
                    </Form>
                </div> :
                <div className="d-flex justify-content-center">
                    <Loader
                        type="Puff"
                        color="#00BFFF"
                        height={50}
                        width={50}
                    />
                </div>
            }
           </>
        );
    }
}

